"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainCdnConfig = void 0;
class DomainCdnConfig {
    constructor() {
    }
    static getAttributeTypeMap() {
        return DomainCdnConfig.attributeTypeMap;
    }
}
exports.DomainCdnConfig = DomainCdnConfig;
DomainCdnConfig.discriminator = undefined;
DomainCdnConfig.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "number",
        "format": "int32"
    },
    {
        "name": "created",
        "baseName": "created",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "updated",
        "baseName": "updated",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "domainId",
        "baseName": "domainId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "certId",
        "baseName": "certId",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "certExpirationDate",
        "baseName": "certExpirationDate",
        "type": "number",
        "format": "int64"
    },
    {
        "name": "cdnId",
        "baseName": "cdnId",
        "type": "string",
        "format": ""
    },
    {
        "name": "cdnGroupId",
        "baseName": "cdnGroupId",
        "type": "string",
        "format": ""
    },
    {
        "name": "sslStatus",
        "baseName": "sslStatus",
        "type": "DomainCdnConfigSslStatusEnum",
        "format": ""
    },
    {
        "name": "validationMethod",
        "baseName": "validationMethod",
        "type": "DomainCdnConfigValidationMethodEnum",
        "format": ""
    },
    {
        "name": "httpBody",
        "baseName": "httpBody",
        "type": "string",
        "format": ""
    },
    {
        "name": "httpUrlPath",
        "baseName": "httpUrlPath",
        "type": "string",
        "format": ""
    },
    {
        "name": "cname",
        "baseName": "cname",
        "type": "string",
        "format": ""
    },
    {
        "name": "cnameTarget",
        "baseName": "cnameTarget",
        "type": "string",
        "format": ""
    },
    {
        "name": "minimumTlsVersion",
        "baseName": "minimumTlsVersion",
        "type": "DomainCdnConfigMinimumTlsVersionEnum",
        "format": ""
    },
    {
        "name": "alternateOriginHostname",
        "baseName": "alternateOriginHostname",
        "type": "string",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "number",
        "format": "int64"
    }
];
//# sourceMappingURL=DomainCdnConfig.js.map